import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import { postServerDataWithPath } from "../../../action/common_action";
import {
  axiosInstnace as Axios,
  calculateAmountAndTax,
} from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import useModel from "../common/useModel";
import ApproveModel from "../common/approveModel";
import RejectModel from "../common/rejectModel";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import Dropdown from "react-dropdown";
import ViewStationsModal from "../audioadminmanagment/ViewStationsModal";

const Incentive = (props) => {
  const [campaigns, handleCampaignList] = useState([]);
  const [dsauser, handleDSAUser] = useState([]);
  const [email, handleemail] = useState(props.email);
    const [showstationlist, handleshowstationlist] = useState(false);
  const [currentStations, handleCurrentStations] = useState([]);


  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));

  // const packagetype = useRef(undefined);

  useEffect(() => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
  }, []);

  const hideshowstations = (e) => {
    handleshowstationlist(!showstationlist);
  };

  const callSearch = () => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
  };

  //Fetching the campaign list
  const getCampaignlist = async (skip, name, id, status, reset) => {
    var paramsConstrct;
    if (!reset) {
      paramsConstrct = {
        skip: 0,
        mentor : adminInfo.role !== 'admin' && adminInfo.role !== 'financeAdmin' ? adminInfo.email:"",
        cluster:
        adminInfo.role !== "admin" &&
        adminInfo.role !== "financeAdmin" && adminInfo.role !== 'stationAdmin'
          ? adminInfo.cluster
          : "",
        withIncentives: true
      };
    }
    
    if (email) {
      paramsConstrct.email = email;
    }
    handleSkip(skip);
    try {
      const data = await Axios.post(
        endPoints.getcampaignsbasedondsa,
        paramsConstrct
      );
      const data1 = await Axios.get(endPoints.getalldsausers, {params:{
        mentor : adminInfo.role !== 'admin' &&
        adminInfo.role !== "financeAdmin"? adminInfo.email:"" ,
        cluster:
        adminInfo.role !== "admin" &&
        adminInfo.role !== "financeAdmin" && adminInfo.role !== 'stationAdmin'
          ? adminInfo.cluster
          : "",

      }});
      
      let result = data.data.data.result;
      if (result) {
        result = result.map((campaign) => {
          return calculateAmountAndTax(campaign);
        });
        handleDSAUser(
          data1.data.data.map((e) => {
            return {
              name: e.name,
              email: e.email,
            };
          })
        );

        handleCampaignList(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const clearSearch = () => {
    window.location.reload(true);
  };

  //Return the table for campaign
  return (
    <div>
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>{" "}
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Trade Partner Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                  Campaign wise Incentives List{" "}
                </span>{" "}
              </div>
              <div className="print_btn">
                {/* <button onClick={showHideExcelPopup}> Download Excel </button>{" "} */}
              </div>{" "}
            </div>
            <form id="search-campaign-form" action="">
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td>
                      <div className="startDate"></div>{" "}
                    </td>{" "}
                    <td>
                      <div className="endDate"></div>{" "}
                    </td>{" "}
                    <td>
                      <div className="drop">
                        <select
                          className="packageType drop-down-icon"
                          value={email}
                          onChange={(event) => handleemail(event.target.value)}
                        >
                          <option value=""> Choose Trade Partner User </option>{" "}
                          {dsauser.map((e) => {
                            return <option value={e.email}>{e.name}</option>;
                          })}
                        </select>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="print_btn">
                        <button type="button" onClick={callSearch}>
                          Search{" "}
                        </button>{" "}
                      </div>
                    </td>{" "}
                    <td>
                      <div className="print_btn">
                        {" "}
                        {/***  <button type="button" onClick={clearSearch}>Clear</button>*/}{" "}
                        <button type="reset" onClick={clearSearch}>
                          Clear{" "}
                        </button>{" "}
                      </div>{" "}
                    </td>
                    <td>                      {props.email && (
                        <div className="print_btn">
                          <button type="button" onClick={props.hide}>
                            Back{" "}
                          </button>
                        </div>
                      )}
 </td>{" "}
                  </tr>
                </tbody>{" "}
              </table>{" "}
            </form>{" "}
            <div
              className={
                campaigns.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>Campaign ID</th>
                    <th>Campaign Name</th>
                    <th>Campaign Payment Date</th>
                    <th> Trade Partner </th>
                    <th>Station</th>
                    <th>Price</th>
                    <th>Incentive (%)</th>
                    <th>Incentive Amount</th>
                    <th>Invoice Number</th>
                    <th>Invoice Date</th>
                    <th>Payment Date</th>
                    <th>Transaction Reference</th>
                  </tr>{" "}
                </thead>{" "}
                <tbody>
                  {" "}
                  {campaigns.map((campaign, i) => (
                    <tr key={i}>
                      <td>{campaign._id}</td>
                      <td>{campaign.name}</td>
                      {campaign.bigFmAudio === "false" &&
                        campaign.paymentdates &&
                        campaign.paymentdates.payId && (
                          <td>
                            {moment(
                              parseInt(campaign.paymentdates.payId)
                            ).format("DD MMM YYYY")}
                          </td>
                        )}
                      {campaign.bigFmAudio === "true" &&
                        campaign.paymentdates &&
                        campaign.paymentdates.payId_1 && (
                          <td>
                            {moment(
                              parseInt(campaign.paymentdates.payId_1)
                            ).format("DD MMM YYYY")}
                          </td>
                        )}
                      {!campaign.paymentdates && (
                        <td>
                          {moment(campaign.createdAt).format("DD MMM YYYY")}
                        </td>
                      )}
                      <td>{campaign.sallerId}</td>
                      <td> {campaign.station.includes(",") ? (
                            <a
                              onClick={(e) => {
                                debugger;
                                handleshowstationlist(true);
                                handleCurrentStations(
                                  campaign.station.split(",")
                                );
                              }}
                            >
                              Multiple ({campaign.station.split(",").length})
                            </a>
                          ) : (
                            campaign.station
                          )}</td>
                      <td>{campaign.amount - campaign.audioCost}</td>
                      {/* <td>{campaign.incentive}</td>
                      <td>
                        {campaign.incentiveAmount &&
                          campaign.incentiveAmount.toFixed(2)}
                      </td> */}
                      <td>{campaign.invoiceno && campaign.incentivecalculated && campaign.incentivecalculated.percent ? campaign.incentivecalculated.percent : campaign.incentive }</td>
                      <td>{campaign.invoiceno && campaign.incentivecalculated && campaign.incentivecalculated.amount ? campaign.incentivecalculated.amount : (campaign.incentiveAmount && campaign.incentiveAmount.toFixed(2))}</td>
                      <td>{campaign.invoiceno}</td>
                      <td>
                        {campaign.invoicedate &&
                          moment(campaign.invoicedate).format("DD MMM YYYY")}
                      </td>
                      <td>
                        {campaign.paymentdate &&
                          moment(campaign.paymentdate).format("DD MMM YYYY")}
                      </td>

                      <td>{campaign.utrno}</td>
                    </tr>
                  ))}{" "}
                </tbody>{" "}
              </table>{" "}
              <div className="paginationTable" />{" "}
              {(skip > 0 || count > 10) && (
                <Pagination getAllData={getCampaignlist} totalRecords={count} />
              )}{" "}
            </div>{" "}
            {campaigns.length === 0 ? <NoData /> : null}{" "}
          </section>{" "}
        </div>{" "}
      </div>{" "}
      {showstationlist && (
        <ViewStationsModal
          stations={currentStations}
          closeAction={hideshowstations}
        />
      )}
      {/* {campaigns.length ===0 && (!searchName && !searchId)?
                      <NoData /> : null} */}{" "}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(Incentive);



// WEBPACK FOOTER //
// ./web/components/admin/dsa_management/incentive.js